import { createContext } from 'react';
import { draftEventTypes } from './useDraftContext';

export type DraftActionsType = {
  [id: number]: {
    args: any[][];
    actions: Function[];
    sync?: boolean;
    requestTypes: string[];
  };
};

export type DraftContextType = {
  loading: boolean;
  isEdit: boolean;
  draftActions: DraftActionsType;
  draftState: any;
  setDraftState: (draftState: any) => void;
  setDraftActions: (draftActions: DraftActionsType) => void;
  addExecuteListener: (listener: Function) => void;
  removeExecuteListener: (listener: Function) => void;
  execute: () => void;
  showDismissConfirmation: boolean;
  setShowDismissConfirmation: (show: boolean) => void;
  showPublishConfirmation: boolean;
  setShowPublishConfirmation: (show: boolean) => void;
  handleEvent: (eventType: keyof typeof draftEventTypes) => void;
};

export const DraftContext = createContext<DraftContextType>({
  loading: false,
  isEdit: false,
  draftActions: {},
  draftState: {},
  setDraftState: (draftActions) => {},
  setDraftActions: (draftActions) => {},
  addExecuteListener: (listener) => {},
  removeExecuteListener: (listener) => {},
  execute: () => {},
  showDismissConfirmation: false,
  setShowDismissConfirmation: () => {},
  showPublishConfirmation: false,
  setShowPublishConfirmation: () => {},
  handleEvent: () => {},
});
